// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3P2cx","inputWrap":"CustomTip_inputWrap__2YVxo"};